"use client";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsTreemap from "highcharts/modules/treemap";
import { getColorByIndex } from "../utils/utils";

HighchartsTreemap(Highcharts);

function TreemapChart({ data }) {
  const options = {
    chart: {
      type: "treemap",
    },
    series: [
      {
        type: "treemap",
        layoutAlgorithm: "squarified",
        data: Object.entries(data).map(([name, value], index) => ({
          name,
          value,
          color: getColorByIndex(index),
        })),
      },
    ],
    title: {
      text: "",
    },
  };
  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
export default TreemapChart;
